import { GameTypeListItem } from '@/models/dictionary/game-type-list.model';
import { defineStore } from 'pinia';
import { api } from '@/services/http.service';
import { ElNotification } from 'element-plus';

interface GameTypeListStore {
  gameTypeList: GameTypeListItem[];
  isGameTypeListLoading: boolean;
}

export const useGameTypeListStore = defineStore({
  id: 'GameTypeListStore',
  state: (): GameTypeListStore => ({
    gameTypeList: [],
    isGameTypeListLoading: false,
  }),
  actions: {
    setGameTypeListLoading(isLoading: boolean): void {
      this.isGameTypeListLoading = isLoading;
    },
    getGameTypeList(): Promise<GameTypeListItem[]> {
      if (this.gameTypeList.length) {
        return Promise.resolve(this.gameTypeList);
      }

      this.setGameTypeListLoading(true);

      return api.dictionary.getGameTypeListRequest.perform()
        .then((data: GameTypeListItem[]) => {
          this.gameTypeList = data;

          return data;
        })
        .catch(error => {
          ElNotification({
            title: 'Error',
            message: error?.response?.data?.message,
            type: 'error',
          });

          return [];
        }).finally(() => {
          this.setGameTypeListLoading(false);
        });
    },
  },
});
